import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Leaderboard from './components/Leaderboard';
import CreateSubmission from './components/CreateSubmission';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Leaderboard />} />
          <Route path="/create" element={<CreateSubmission />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 